var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74609 3.5H7.99609C7.16767 3.5 6.49609 4.17157 6.49609 5V19C6.49609 19.8284 7.16767 20.5 7.99609 20.5H15.9961C16.8245 20.5 17.4961 19.8284 17.4961 19V5C17.4961 4.17157 16.8245 3.5 15.9961 3.5H15.2461C15.2461 4.19036 14.6864 4.75 13.9961 4.75H9.99609C9.30574 4.75 8.74609 4.19036 8.74609 3.5ZM15.9961 2C17.6529 2 18.9961 3.34315 18.9961 5V19C18.9961 20.6569 17.6529 22 15.9961 22H7.99609C6.33924 22 4.99609 20.6569 4.99609 19V5C4.99609 3.34315 6.33924 2 7.99609 2H15.9961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.48d401e048000c76e8e1331b440eb446.svg";
export { ForwardRef as ReactComponent };